<template>
  <v-app id="searchArrivals">
    <v-main>
     <v-container fluid>
       <v-row no-gutters>
        <v-card class="px-2">
            <v-text-field
            v-model="search"
              label="Search"
              single-line
              hide-details
             >
            </v-text-field>
        
            <v-data-table 
            :items="items" 
            :items-per-page="50" 
            :footer-props="{'items-per-page-options': [50, 100, 200, 300, 500]}"
            :headers="headers"
            fixed-headers
            :search="search"        
            >
            <template v-slot:item="props">
              <tr>
              <td @click="$router.open('/huov/onHuov/' + props.item.huov_encrid)"><a> {{props.item.huov_code}} </a></td>
              <td><v-chip :color=props.item.hust_kleur>{{props.item.hust_code}}</v-chip></td>
              <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)"><a> {{props.item.huis_code}} <br> {{props.item.huis_naam}} </a></td>
              <td class="td_markup">{{ $moment(props.item.huov_van_dat).format("DD-MMM-YYYY dddd") }}</td>
              <td class="td_markup">{{ $moment(props.item.huov_dt).format("DD-MMM-YYYY") }}</td>
                         
              <td class="td_markup" @click="$router.open('/eign/onEign/' + props.item.eign_encrid)"><a> {{props.item.eign_naam}} </a></td>
              <td class="td_markup">{{props.item.eign_landtaal}} </td>
              <td class="td_markup">{{props.item.eign_tel1_vcs}} </td>
              <td><v-chip :color=props.item.mail_kleur>{{props.item.mail}}</v-chip></td>
              <td class="td_markup">{{props.item.sms}} </td>
              <td class="td_markup">{{props.item.login}} </td>
              <td class="td_markup" @click="$router.open('/klnt/onKlnt/' + props.item.klnt_encrid)"><a> {{props.item.klnt_naam}} </a></td>
              <td><v-icon  @click="nott(props.item.huov_encrid);">mdi-clipboard-text-outline</v-icon></td>
              </tr>
              <tr v-for="nottRecord in props.item.nott" :key="nottRecord.nott_dt">
                <td>{{nottRecord.nott_dt}}</td>
                <td>{{nottRecord.nott_gebr_code}}</td>
                <td colspan=11>{{nottRecord.nott_tekst}}</td>
               </tr>  
            </template>
            </v-data-table>
        </v-card>
        </v-row>
     </v-container>
    </v-main>
    <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main"/>
    <nott ref="nott"></nott>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import nott from "@/components/nott";
 export default {
  components: {
    navBar,
    nott
  },
  data() {
    return {
      items: [],
      search: '',
      headers: [
        {text: 'Id', value: 'huov_code'},
        {text: 'Status', value: 'hust_code'},
        {text: 'Accommodation', value: 'huis_code'},
        {text: 'Arrival', value: 'huov_van_dat'},
        {text: 'Booking', value: 'huov_dt'},
        {text: 'Caretaker', value: 'eign_naam'}, 
        {text: 'Crt / Lang', value: 'eign_landtaal'},
        {text: 'Telephone', value: 'eign_tel1_vcs'}, 
        {text: 'Last email read  days / date', value: 'mail'}, 
        {text: 'SMS', value: 'sms'},
        {text: 'Login', value: 'login'},
        {text: 'Guest', value: 'klnt_naam'},
        {text: 'Remark'}
      ]
    }  
  },
  mounted() {
      this.results = true;
      this.$axios
        .post("ares/json/ares/huov/searchArrivals.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchArrivals"
          },
          searchArrivals: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.searchArrivals;
          }
        })
        .finally(() => {
          this.loading = false;
        });
  },
  methods: {
    nott(huov_encrid) {
      this.$refs.nott.open("huov",huov_encrid,"Arrivals - Host mail not read");
    },
  }
};

</script> 
<style scoped>
  .td_markup{
    vertical-align: top;
    border-top: 5px solid transparent; /* trick to add padding to a TD element (which is not possible with CSS normally) */
  }
</style>